import React, { useState, useMemo } from 'react'

// create context
export const SidebarContext = React.createContext()

export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [isDesktopSidebarHidden, setIsDesktopSidebarHidden] = useState(false)

  const value = useMemo(
    () => {
      const toggleSidebar = () => {
        setIsSidebarOpen(prevState => !prevState)
      }

      const closeSidebar = () => {
        setIsSidebarOpen(false)
      }

      const toggleDesktopSidebar = () => {
        setIsDesktopSidebarHidden(prevState => !prevState)
      }

      return ({
        isSidebarOpen,
        toggleSidebar,
        closeSidebar,
        isDesktopSidebarHidden,
        toggleDesktopSidebar,
        setDesktopSidebarHidden: (value) => setIsDesktopSidebarHidden(value),
      })
    },
    [isSidebarOpen, isDesktopSidebarHidden]
  )

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
}
